export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

export function setDateGenerate(state, date_generate) {
    state.params.date_generate = date_generate;
}

export function setSuggestedReplacement(state, data) {
    state.suggestedReplacement = data;
}



// WEBPACK FOOTER //
// ./src/modules/suggested_replacement/mutations.js